import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/labels')({
  beforeLoad: () => {
    throw redirect({
      to: '/settings',
      search: { section: 'labels' },
    })
  },
  component: () => null,
})
